import React, { useEffect } from "react";
import AboutUsImg from "../../assets/images/aboutus.png";
import "aos/dist/aos.css";
import AOS from "aos";
import Swal from "sweetalert2";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-full h-full box-border p-8 flex justify-center items-center md:flex-row flex-col-reverse relative rounded-3xl my-12">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-blue-50/20 rounded-3xl z-0"></div>

      <div
        className="md:w-2/5 w-full flex justify-center items-center h-full z-10 relative"
        data-aos="fade-right"
      >
        <div className="h-5/6 relative">
          <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-blue-100/50 filter blur-xl"></div>
          <img
            alt="About Fusion Cab"
            src={AboutUsImg}
            className="w-[90%] drop-shadow-2xl rounded-lg relative"
            style={{
              maxHeight: "550px",
            }}
          />
          <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-full bg-blue-100/70 filter blur-xl"></div>
        </div>
      </div>
      <div className="md:w-3/5 w-full z-10 relative">
        <div className="w-full flex flex-col gap-4">
          <div
            className="font-mazzardbold text-4xl md:text-5xl my-3 bg-clip-text text-transparent bg-gradient-to-r from-black to-blue-900"
            data-aos="fade-left"
          >
            About Us
          </div>
          <div className="my-2 text-left flex flex-col gap-4">
            <p
              data-aos="fade-left"
              data-aos-delay="400"
              className="text-gray-800 leading-relaxed"
            >
              At{" "}
              <strong className="font-mazzardbold text-blue-900">
                {" "}
                Fusion Cab
              </strong>
              , we are more than just a transportation service; we are a
              revolutionary force in the cab rental industry. Our mission is to
              bridge the gap between technology and transportation, offering a
              seamless, efficient, and customer-centric experience. With a focus
              on intercity travel, airport transfers, and hourly rentals, we
              provide a range of services tailored to meet the diverse needs of
              our clients.
            </p>
            <p
              data-aos="fade-left"
              data-aos-delay="600"
              className="text-gray-800 leading-relaxed"
            >
              Our cutting-edge tech platform connects businesses,
              intermediaries, and service providers in a way that ensures a
              smooth journey from booking to destination.
            </p>
            <p
              data-aos="fade-left"
              data-aos-delay="800"
              className="text-gray-800 leading-relaxed"
            >
              We believe in the power of innovation and are committed to
              transforming the commercial cab rental landscape into one that is
              organized, reliable, and accessible to all.
            </p>
          </div>
          <div
            className="my-4 text-left"
            data-aos="fade-left"
            data-aos-delay="1000"
          >
            <button
              className="rounded-full px-8 py-3 bg-gradient-to-r from-blue-800 to-blue-900 text-white font-medium shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              onClick={() => {
                Swal.fire(
                  "Coming Soon",
                  "The app will be available soon!",
                  "info"
                );
              }}
            >
              Download App
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
